export enum UserContactsTypes {
  GET_USER_CONTACTS_REQUEST = '@user_contacts/GET_USER_CONTACTS_REQUEST',
  GET_USER_CONTACTS_SUCCESS = '@user_contacts/GET_USER_CONTACTS_SUCCESS',
  GET_USER_CONTACTS_FAILURE = '@user_contacts/GET_USER_CONTACTS_FAILURE',
}

export interface UserContactSelectTypes {
  label: string | null;
  value: number | null;
}

export interface UserContactData {
  acesso_servico_online: boolean | null;
  ativo: boolean | null;
  cargo_id: number | null;
  cliente_id: number | null;
  email: string | null;
  id: number | null;
  nome: string | null;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface UserContactsState {
  readonly user_contacts: Array<UserContactData>;
  readonly request: RequestState;
}
